module.exports = __webpack_public_path__ + "img/pixeon-con.ec82ff77.png";